/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Search_PlaceholderInputs */

const en_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search conversations...`)
};

const es_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar conversaciones...`)
};

const fr_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des conversations...`)
};

const de_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltungen durchsuchen...`)
};

const ja_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを検索...`)
};

const zh_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索对话...`)
};

const ar_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث في المحادثات...`)
};

const id_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari percakapan...`)
};

const it_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca conversazioni...`)
};

const ru_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по беседам...`)
};

const pt_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar conversas...`)
};

const ko_inbox_search_placeholder = /** @type {(inputs: Inbox_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대화 검색...`)
};

/**
* | output |
* | --- |
* | "Search conversations..." |
*
* @param {Inbox_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const inbox_search_placeholder = /** @type {((inputs?: Inbox_Search_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Search_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inbox_search_placeholder(inputs)
	if (locale === "es") return es_inbox_search_placeholder(inputs)
	if (locale === "fr") return fr_inbox_search_placeholder(inputs)
	if (locale === "de") return de_inbox_search_placeholder(inputs)
	if (locale === "ja") return ja_inbox_search_placeholder(inputs)
	if (locale === "zh") return zh_inbox_search_placeholder(inputs)
	if (locale === "ar") return ar_inbox_search_placeholder(inputs)
	if (locale === "id") return id_inbox_search_placeholder(inputs)
	if (locale === "it") return it_inbox_search_placeholder(inputs)
	if (locale === "ru") return ru_inbox_search_placeholder(inputs)
	if (locale === "pt") return pt_inbox_search_placeholder(inputs)
	return ko_inbox_search_placeholder(inputs)
});